<template>
  <div
    class="
      relative
      flex
      items-top
      justify-center
      min-h-screen
      bg-gray-100
    "
  >
    <div class="max-w-6xl mx-auto sm:px-6 lg:px-8">
      <div class="flex justify-center pt-8 sm:justify-start">
        <img
          src="/img/RA-logo-02.png"
          class="h-20 w-auto text-gray-700 sm:h-20"
        />
        <img
          src="/img/logo-thnic.svg"
          class="h-20 w-auto text-gray-700 sm:h-20"
        />
        <div class="ml-5">
          <div
            class="text-sm sm:text-2xl text-blue-900"
          >
            Workshop สร้าง Sale Page เปิดร้านออนไลน์ ด้วยเว็บไซต์หน้าเดียว ฉบับจับมือทำ
          </div>
          <div class="text-sm sm:text-sm mt-1">
            จัดโดย Robinhood Academy ร่วมกับ มูลนิธิศูนย์สารสนเทศเครือข่ายไทย
          </div>
        </div>
      </div>

      <div class="bg-white overflow-hidden shadow sm:rounded-lg">
        <div class="bg-blue-900 px-6 py-8">
          <div class="text-white text-center text-xl font-semibold">
            <span class="text-yellow-500">Step 1</span> :
            เลือกและตรวจสอบชื่อโดเมน<span
              class="font-normal underline text-lg ml-2"
              >ไม่ต้องใส่ www.</span
            >
          </div>
          <div class="mt-4 flex justify-center h-10">
            <input
              v-model="form.domain_name"
              placeholder="ชื่อโดเมนที่ต้องการ"
              class="
                px-3
                border-gray-300
                focus:border-indigo-300
                focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                rounded-md
                shadow-sm
              "
              @keyup="startAgain"
            />
            <select
              v-model="form.tld"
              class="
                ml-1
                border-gray-300
                focus:border-indigo-300
                focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                rounded-md
                shadow-sm
              "
              @change="startAgain"
            >
              <option
                v-for="(tld, index) in tlds"
                :key="`bt-${index}`"
                :value="tld"
              >
                {{ tld }}
              </option>
            </select>
            <button
              class="
                ml-2
                px-4
                bg-yellow-500
                border border-transparent
                rounded-md
                text-sm
                sm:text-base
                text-white
                tracking-widest
                hover:bg-yellow-600
                active:bg-yellow-700
                focus:outline-none
                focus:border-yellow-700
                focus:shadow-outline-white
                transition
                ease-in-out
                duration-150
              "
              :class="{
                'opacity-70': form.processing || isChecking || !isDomainValid,
              }"
              :disabled="form.processing || isChecking || !isDomainValid"
              @click="checkDomain"
            >
              ตรวจสอบชื่อว่าง
            </button>
          </div>
          <div v-show="domainResult" class="mt-4">
            <p class="text-center" :class="{'text-green-200': isOpenNextSteps, 'text-yellow-300': !isOpenNextSteps }">
              {{ domainResult }}
            </p>
          </div>
          <div v-show="form.errors.domain_name" class="mt-2">
            <p class="text-sm text-yellow-300 text-center">
              {{ form.errors.domain_name }}
            </p>
            <p class="text-sm text-yellow-300 text-center">
              {{ form.errors.domain }}
            </p>
          </div>
        </div>

        <form v-show="isOpenNextSteps" @submit.prevent="doRegistration">
          <div class="px-6 py-8">
            <div class="text-blue-900 text-center text-xl font-semibold">
              <span class="text-yellow-500">Step 2</span> :
              กรอกข้อมูลผู้เข้าร่วมโครงการ
            </div>
            <div class="text-red-700 text-sm">*จำเป็นต้องกรอก</div>
            <div class="text-lg font-semibold mt-4 mb-4">ข้อมูลภาษาไทย</div>
            <div class="grid grid-cols-12 gap-4">
              <div class="col-span-4 md:col-span-2">
                <breeze-label
                  for="manager_title_code"
                  value="ชื่อผู้ติดต่อ (คำนำหน้า)*"
                />
                <select
                  v-model="form.manager_title_code"
                  class="
                    w-full
                    mt-1
                    border-gray-300
                    focus:border-indigo-300
                    focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                    rounded-md
                    shadow-sm
                  "
                  @change="completePersonTitle()"
                >
                  <option :value="null" disabled>-- เลือก --</option>
                  <option
                    v-for="(personTitle, index) in personTitles"
                    :key="`jt-${index}`"
                    :value="personTitle.titleid"
                  >
                    {{ personTitle.titleth }}
                  </option>
                </select>
                <breeze-input-error
                  :message="form.errors.manager_title_code"
                  class="mt-2"
                />
              </div>

              <div class="col-span-8 md:col-span-5">
                <breeze-label
                  for="manager_firstname"
                  value="ชื่อผู้ติดต่อ (ชื่อ)*"
                />
                <breeze-input
                  id="manager_firstname"
                  type="text"
                  class="mt-1 block w-full"
                  placeholder="เช่น สมชาย"
                  v-model="form.manager_firstname"
                />
                <breeze-input-error
                  :message="form.errors.manager_firstname"
                  class="mt-2"
                />
              </div>

              <div class="col-span-12 md:col-span-5">
                <breeze-label
                  for="manager_lastname"
                  value="ชื่อผู้ติดต่อ (นามสกุล)*"
                />
                <breeze-input
                  id="manager_lastname"
                  type="text"
                  class="mt-1 block w-full"
                  placeholder="เช่น ส่งเสริมพาณิชย์"
                  v-model="form.manager_lastname"
                />
                <breeze-input-error
                  :message="form.errors.manager_lastname"
                  class="mt-2"
                />
              </div>
            </div>

            <div class="text-lg font-semibold mt-8 mb-4">ที่อยู่ภาษาไทย</div>
            <div class="grid grid-cols-12 gap-4">
              <div class="col-span-4 sm:col-span-2">
                <breeze-label for="house_no" value="เลขที่*" />
                <breeze-input
                  id="house_no"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.house_no"
                  @keyup="completeHouseNo"
                />
                <breeze-input-error
                  :message="form.errors.house_no"
                  class="mt-2"
                />
              </div>

              <div class="col-span-8 sm:col-span-3">
                <breeze-label for="building" value="อาคาร/หมู่บ้าน" />
                <breeze-input
                  id="building"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.building"
                />
                <breeze-input-error
                  :message="form.errors.building"
                  class="mt-2"
                />
              </div>

              <div class="col-span-6 sm:col-span-1">
                <breeze-label for="floor" value="ชั้น" />
                <breeze-input
                  id="floor"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.floor"
                  @keyup="completeFloor"
                />
                <breeze-input-error :message="form.errors.floor" class="mt-2" />
              </div>

              <div class="col-span-6 sm:col-span-1">
                <breeze-label for="moo" value="หมู่ที่" />
                <breeze-input
                  id="moo"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.moo"
                  @keyup="completeMoo"
                />
                <breeze-input-error :message="form.errors.moo" class="mt-2" />
              </div>

              <div class="col-span-6 sm:col-span-2">
                <breeze-label for="soi" value="ซอย" />
                <breeze-input
                  id="soi"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.soi"
                />
                <breeze-input-error :message="form.errors.soi" class="mt-2" />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label for="road" value="ถนน" />
                <breeze-input
                  id="road"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.road"
                />
                <breeze-input-error :message="form.errors.road" class="mt-2" />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label for="province_code" value="จังหวัด*" />
                <select
                  v-model="form.province_code"
                  class="
                    w-full
                    mt-1
                    border-gray-300
                    focus:border-indigo-300
                    focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                    rounded-md
                    shadow-sm
                  "
                  @change="getDistrict"
                >
                  <option :value="null" disabled>-- เลือกจังหวัด --</option>
                  <option
                    v-for="(province, index) in provinces"
                    :key="`ct-${index}`"
                    :value="province.provincecode"
                  >
                    {{ province.provinceth }}
                  </option>
                </select>
                <breeze-input-error
                  :message="form.errors.province_code"
                  class="mt-2"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label for="district_code" value="อำเภอ/เขต*" />
                <select
                  v-model="form.district_code"
                  class="
                    w-full
                    mt-1
                    border-gray-300
                    focus:border-indigo-300
                    focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                    rounded-md
                    shadow-sm
                  "
                  @change="getSubDistrict"
                >
                  <option :value="null" disabled>-- เลือกอำเภอ/เขต--</option>
                  <option
                    v-for="(district, index) in districts"
                    :key="`ct-${index}`"
                    :value="district.district_code"
                  >
                    {{ district.district_th }}
                  </option>
                </select>
                <breeze-input-error
                  :message="form.errors.district_code"
                  class="mt-2"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label for="sub_district_code" value="ตำบล/แขวง*" />
                <select
                  v-model="form.sub_district_code"
                  class="
                    w-full
                    mt-1
                    border-gray-300
                    focus:border-indigo-300
                    focus:ring focus:ring-indigo-200 focus:ring-opacity-50
                    rounded-md
                    shadow-sm
                  "
                  @change="getPostalCode"
                >
                  <option :value="null" disabled>-- เลือกตำบล/แขวง--</option>
                  <option
                    v-for="(subDistrict, index) in subDistricts"
                    :key="`ct-${index}`"
                    :value="subDistrict.sub_district_code"
                  >
                    {{ subDistrict.sub_district_th }}
                  </option>
                </select>
                <breeze-input-error
                  :message="form.errors.sub_district_code"
                  class="mt-2"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <breeze-label for="post_code" value="รหัสไปรษณีย์*" />
                <breeze-input
                  id="post_code"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.post_code"
                />
                <breeze-input-error
                  :message="form.errors.post_code"
                  class="mt-2"
                />
              </div>

              <div class="col-span-12 sm:col-span-3">
                <breeze-label for="email" value="อีเมล*" />
                <breeze-input
                  id="email"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.email"
                />
                <breeze-input-error :message="form.errors.email" class="mt-2" />
              </div>

              <div class="col-span-12 sm:col-span-3">
                <breeze-label
                  for="telephone"
                  value="เบอร์โทรศัพท์/เบอร์มือถือ*"
                />
                <breeze-input
                  id="telephone"
                  type="text"
                  class="mt-1 block w-full"
                  v-model="form.telephone"
                />
                <breeze-input-error
                  :message="form.errors.telephone"
                  class="mt-2"
                />
              </div>
            </div>
            
          </div>

          <div class="grid bg-blue-50 border-t border-gray-200">
            <div class="p-6">
              <div class="text-blue-900 text-center text-xl font-semibold mb-4">
                <span class="text-yellow-500">Step 3</span> :
                ข้อกำหนดและเงื่อนไข
              </div>
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 border-t border-gray-200">
            <div class="p-6">
              <div class="flex items-center">
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  class="w-8 h-8 text-gray-500"
                >
                  <path
                    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                  ></path>
                </svg>
                <div class="ml-4 text-lg leading-7 font-semibold">
                  <span class="text-blue-900">ข้อกำหนดและเงื่อนไข</span>
                </div>
              </div>

              <div class="ml-12">
                <div class="mt-2 text-gray-600 text-sm">
                  <ul class="mt-2 ml-3 list-outside list-disc">
                    <li>สามารถจดทะเบียนโดเมนได้เพียง 1 ชื่อเท่านั้น</li>
                    <li>
                      ได้รับ ชื่อ domain .in.th และ .ไทย ฟรีเป็นระยะเวลาหนึ่งปี
                    </li>
                    <li>
                      ได้รับบริการ Zavanna Sale Page ฟรีเป็นระยะเวลาหนึ่งปี
                    </li>
                    <li v-if="type == 'C'">
                      สำหรับโดเมน .co.th ชื่อโดเมนจำเป็นต้องสอดคล้อง,
                      เป็นส่วนใดส่วนหนึ่ง หรือย่อมาจากชื่อองค์กรหรือร้านค้าเท่านั้น
                    </li>
                    <li>
                      มูลนิธิฯขอสงวนสิทธิ์การปฏิเสธการจดทะเบียนชื่อโดเมนที่ไม่เป็นไปตามเงื่อนไขข้างต้น
                    </li>
                    <li>
                      หากต้องการต่ออายุโดเมนสามารถติดต่อ support@dotarai.com เพื่อรับข้อมูลการต่ออายุ
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="p-6 border-t border-gray-200 md:border-t-0 md:border-l">
              <div class="flex items-center">
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  class="w-8 h-8 text-gray-500"
                >
                  <path
                    d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
                <div class="ml-4 text-lg leading-7 font-semibold">
                  <span class="text-blue-900"
                    >สิ่งที่จะได้รับหลังจากลงทะเบียน</span
                  >
                </div>
              </div>

              <div class="ml-12">
                <div class="mt-2 text-gray-600 text-sm">
                  หลังจากที่มูลนิธิฯ
                  ตรวจสอบข้อมูลยืนยันตัวตนเรียบร้อยแล้ว
                  และส่งจดทะเบียนชื่อโดเมนสำเร็จ ท่านจะได้รับ
                  <ul class="mt-2 ml-3 list-outside list-disc">
                    <li>ชื่อ Domain ตามที่ท่านได้เลือกไว้</li>
                    <li>Zavanna Sale Page </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="md:col-span-2 p-6 border-t border-gray-200 text-center">
              <div classs="flex items-center justify-center">
                <label>
                  <breeze-checkbox
                    name="isAgreedOnTerm"
                    v-model:checked="isAgreedOnTerm"
                  />
                  <span class="ml-2 text-sm text-gray-600"
                    >ข้าพเจ้าได้อ่านและยอมรับเงื่อนไขของโครงการข้างต้นแล้ว</span
                  >
                </label>
              </div>
              <button
                class="
                  mt-4
                  px-4
                  py-2
                  bg-blue-900
                  border border-transparent
                  rounded-md
                  text-xl text-white
                  tracking-widest
                  hover:bg-yellow-600
                  active:bg-yellow-700
                  focus:outline-none
                  focus:border-yellow-700
                  focus:shadow-outline-white
                  transition
                  ease-in-out
                  duration-150
                "
                :class="{
                  'opacity-50': form.processing || !isAgreedOnTerm,
                }"
                :disabled="form.processing || !isAgreedOnTerm"
              >
                ลงทะเบียนเข้าร่วมโครงการ
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import BreezeCheckbox from "@/Components/Checkbox";
import BreezeLabel from "@/Components/Label";
import BreezeInput from "@/Components/Input";
import BreezeInputError from "@/Components/InputError";

export default {
  props: ["type"],
  components: {
    BreezeCheckbox,
    BreezeLabel,
    BreezeInput,
    BreezeInputError,
  },
  data() {
    return {
      tlds:
        this.type == "C"
          ? [".co.th", ".online.th", ".shop.th"]
          : this.type=="R"? [".in.th"]:[".online.th", ".shop.th"],

      commercialTypes: [],
      deliveryTypes: [],
      districts: [],
      juristicTitles: [],
      paymentTypes: [],
      personTitles: [],
      provinces: [],
      reserveTypes: [],
      subDistricts: [],

      form: this.$inertia.form({
        domain_name: null,
        domain: null,
        tld: ".in.th",
        email: null,
        type: this.type,
        telephone: null,
        manager_title_code: null,
        manager_title: null,
        manager_firstname: null,
        manager_lastname: null,
        house_no: null,
        building: null,
        floor: null,
        moo: null,
        soi: null,
        road: null,
        sub_district_code: null,
        sub_district_name: null,
        district_code: null,
        district_name: null,
        province_code: null,
        province_name: null,
        post_code: null,
        need_sale_page: true,
      }),
      isAgreedOnTerm: false,
      isOpenNextSteps: false,
      isChecking: false,
      domainResult: null,
    };
  },
  created() {
    //load master
    axios
      .all([
        axios.get(route("master_data.commercial_types")),
        axios.get(route("master_data.delivery_types")),
        axios.get(route("master_data.juristic_titles")),
        axios.get(route("master_data.payment_types")),
        axios.get(route("master_data.person_titles")),
        axios.get(route("master_data.provinces")),
        axios.get(route("master_data.reserve_types")),
      ])
      .then(
        axios.spread(
          (
            commercialTypesRes,
            deliveryTypesRes,
            juristicTitlesRes,
            paymentTypesRes,
            personTitlesRes,
            provincesRes,
            reserveTypesRes
          ) => {
            this.commercialTypes = commercialTypesRes.data;
            this.deliveryTypes = deliveryTypesRes.data;
            this.juristicTitles = juristicTitlesRes.data;
            this.paymentTypes = paymentTypesRes.data;
            this.personTitles = personTitlesRes.data;
            this.provinces = provincesRes.data;
            this.reserveTypes = reserveTypesRes.data;
          }
        )
      );
  },
  methods: {
    completeJuristicTitle() {
      let selectedJuristicTitle = _.find(
        this.juristicTitles,
        (juristicTitle) => juristicTitle.titleid == this.form.owner_title_code
      );
      this.form.owner_title = selectedJuristicTitle.titleth;
      this.form.owner_title_en = selectedJuristicTitle.titleen;
    },
    selectedOwnerTitle() {
      let selectedOwnerTitle = _.find(
        this.personTitles,
        (personTitle) => personTitle.titleid == this.form.owner_title_code
      );
      this.form.owner_title = selectedOwnerTitle.titleth;
      this.form.owner_title_en = selectedOwnerTitle.titleen;
    },
    completePersonTitle() {
      let selectedPersonTitle = _.find(
        this.personTitles,
        (personTitle) => personTitle.titleid == this.form.manager_title_code
      );
      this.form.manager_title = selectedPersonTitle.titleth;
      this.form.manager_title_en = selectedPersonTitle.titleen;
    },
    completeHouseNo() {
      this.form.house_no_en = this.form.house_no;
    },
    completeFloor() {
      this.form.floor_en = this.form.floor;
    },
    completeMoo() {
      this.form.moo_en = this.form.moo;
    },
    getDistrict() {
      let selectedProvince = _.find(
        this.provinces,
        (province) => province.provincecode == this.form.province_code
      );
      this.form.province_name = selectedProvince.provinceth;
      this.form.province_name_en = selectedProvince.provinceen;
      axios
        .get(
          route("master_data.districts", {
            provinceCode: this.form.province_code,
          })
        )
        .then((response) => (this.districts = response.data));
    },
    getSubDistrict() {
      let selectedDistrict = _.find(
        this.districts,
        (district) => district.district_code == this.form.district_code
      );
      this.form.district_name = selectedDistrict.district_th;
      this.form.district_name_en = selectedDistrict.district_en;
      axios
        .get(
          route("master_data.sub_districts", {
            provinceCode: this.form.province_code,
            districtCode: this.form.district_code,
          })
        )
        .then((response) => (this.subDistricts = response.data));
    },
    getPostalCode() {
      let selectedSubDistrict = _.find(
        this.subDistricts,
        (subDistrict) =>
          subDistrict.sub_district_code == this.form.sub_district_code
      );
      this.form.sub_district_name = selectedSubDistrict.sub_district_th;
      this.form.sub_district_name_en = selectedSubDistrict.sub_district_en;
      this.form.post_code = selectedSubDistrict.postcode;
    },
    doRegistration() {
      this.form.domain = _.trim(_.toLower(this.form.domain_name)) + this.form.tld;
      this.form.post(route("registrations.store"), {
        preserveScroll: true,
        onSuccess: () => this.form.reset(),
      });
    },
    startAgain() {
      this.isOpenNextSteps = false;
      this.domainResult = null;
    },
    checkDomain() {
      this.isChecking = true;
      this.isOpenNextSteps = false;

      axios
        .post(
          route("dotarai.check_domain", {
            domain_name: _.trim(_.toLower(this.form.domain_name)),
            tld: this.form.tld,
          })
        )
        .then((response) => {
          if (response.data.result == 'success') {
            if (response.data.data == true)
              this.isOpenNextSteps = true;

            this.domainResult = response.data.message;
          } else {
            this.domainResult = response.data.message;
          }

          this.isChecking = false;
        });
    },
  },
  computed: {
    isDomainValid() {
      return !this.$isEmpty(this.form.domain_name);
    },
  },
};
</script>
